export const AdminMenuSetsPageController = {
    index(): void {},
    create(): void {},
    store(): void {},
    order(): void {},
    edit(): void {},
    update(): void {},
    bulkDestroy(): void {},
    destroy(): void {},
};
